import {APIClient} from "../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();

// get Companies
export const getCompanies = () => api.get(url.GET_COMPANIES);
export const getCompaniesByUser = (userId: string) => api.get(`${url.GET_COMPANIES}?userId=${userId}`);
export const getCompanyById = (id: string) => api.get(`${url.GET_COMPANIES}/${id}`);

// add Companies
export const addCompany = (company: any) =>
    api.create(url.ADD_NEW_COMPANIES, company);

// update Companies
export const updateCompany = (company: any) =>
    api.put(url.UPDATE_COMPANIES + '/' + company.id, company);

// delete Companies
export const deleteCompany = (companyId: string) =>
    api.delete(url.DELETE_COMPANIES + '/' + companyId);

// add Company Signature
export const addCompanySignature = (signatureData: any) =>
    api.create(url.ADD_COMPANY_SIGNATURE, signatureData, {headers: {"Content-Type": "multipart/form-data"},});

// Company Establishments
export const getEstablishments = (companyId?: string) => {
    let requestUrl = url.GET_ESTABLISHMENTS;
    if (companyId) {
        requestUrl += `?companyId=${companyId}`;
    }
    return api.get(requestUrl);
};
export const getEstablishment = (id: string) => api.get(`${url.GET_ESTABLISHMENTS}/${id}`);
export const addEstablishment = (establishment: any) => api.create(url.ADD_NEW_ESTABLISHMENT, establishment);
export const updateEstablishment = (establishment: any) => api.put(`${url.UPDATE_ESTABLISHMENT}/${establishment.id}`, establishment);
export const deleteEstablishment = (id: string) => api.delete(`${url.DELETE_ESTABLISHMENT}/${id}`);

// Company Emission Points
export const getEmissionPoints = (establishmentId?: string) => {
    let requestUrl = url.GET_EMISSION_POINTS;
    if (establishmentId) {
        requestUrl += `?establishmentId=${establishmentId}`;
    }
    return api.get(requestUrl);
};
export const getEmissionPoint = (id: string) => api.get(`${url.GET_EMISSION_POINTS}/${id}`);
export const addEmissionPoint = (emissionPoint: any) => api.create(url.ADD_NEW_EMISSION_POINT, emissionPoint);
export const updateEmissionPoint = (emissionPoint: any) => api.put(`${url.UPDATE_EMISSION_POINT}/${emissionPoint.id}`, emissionPoint);
export const deleteEmissionPoint = (id: string) => api.delete(`${url.DELETE_EMISSION_POINT}/${id}`);
